import breadcrumbs from './breadcrumbs'

export default {
  breadcrumbs,
}
